const BASE_PATH = 'api/students/'

const types = {
  STUDENT_LIST_REQUEST: BASE_PATH + 'STUDENT_LIST_REQUEST',
  STUDENT_LIST_SUCCESS: BASE_PATH + 'STUDENT_LIST_SUCCESS',
  STUDENT_LIST_FAILURE: BASE_PATH + 'STUDENT_LIST_FAILURE',
}

export default types
